import { render, staticRenderFns } from "./CheckboxElementCustom.vue?vue&type=template&id=6aa3609e&scoped=true&"
import script from "./CheckboxElementCustom.vue?vue&type=script&lang=js&"
export * from "./CheckboxElementCustom.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxElementCustom.vue?vue&type=style&index=0&id=6aa3609e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa3609e",
  null
  
)

export default component.exports